﻿/* STEIN & VOSS — Klarna-Popup: Betrag aus Produktpreis, oeffnen/schliessen */
(function () {
  'use strict';

  var modal = document.querySelector('[data-sv-klarna-modal]');
  if (!modal) return;

  var lastFocus = null;

  function priceText() {
    var el = document.querySelector('.product__info-container .price-item--regular');
    if (!el) return null;
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    return t || null;
  }

  function fill() {
    var p = priceText() || '–';
    modal.querySelectorAll('[data-sv-klarna-price]').forEach(function (n) {
      n.textContent = p;
    });
  }

  function openModal() {
    lastFocus = document.activeElement;
    fill();
    modal.hidden = false;
    document.body.classList.add('sv-klarna-lock');
    var btn = modal.querySelector('.sv-klarna-modal__close-btn');
    if (btn) btn.focus();
    document.addEventListener('keydown', onKey);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('sv-klarna-lock');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') closeModal();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sv-klarna-open]')) {
      e.preventDefault();
      openModal();
    } else if (e.target.closest('[data-sv-klarna-close]')) {
      e.preventDefault();
      closeModal();
    }
  });
})();
